import { Component } from '@angular/core';
import { GIFS } from 'src/app/core/constants/icons';
import { DialogService } from 'src/app/core/services/dialog.service';

@Component({
  selector: 'app-animation-dialog',
  templateUrl: './animation-dialog.component.html',
  styleUrls: ['./animation-dialog.component.scss']
})
export class AnimationDialogComponent {
  SCAN_GIF = GIFS.SCAN;

  constructor(protected dialogService: DialogService) {}
}
